<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0 mt-2"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img :src="require('@/assets/avatars/1.jpg')"  class="c-avatar-img" style="width: 100%; height: 100%; object-fit: cover" />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownItem @click="logout">
      <CIcon name="cil-lock-locked" size="xl" /> {{ $t('common.logout') }}
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "TheHeaderDropdownAccnt",
  
  methods: {
    ...mapActions("auth", ["logout"]),
  },
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
.c-header-nav .dropdown-item {
  min-width: 250px;
}
</style>
